import { useEffect, useState } from "react";
import { TENANT_READS_BLOCKED_EVENT, type SubscriptionInfo } from "../lib/api.js";

/**
 * F-MANDANTENSTATUS1 — Vollseite gesperrt.
 *
 * A suspended tenant is blocked at once: the session projection already says
 * so. Every other blocked read (cancelled or expired past the 90-day read
 * window) is only known when the API refuses a GET, so the shell also keeps a
 * sticky flag from {@link TENANT_READS_BLOCKED_EVENT}. A reload clears it.
 */
export function subscriptionBlocksReads(subscription: SubscriptionInfo | undefined): boolean {
  return subscription?.status === "suspended";
}

export function useTenantReadBlock(subscription: SubscriptionInfo | undefined): boolean {
  const [refused, setRefused] = useState(false);
  useEffect(() => {
    const onBlocked = () => setRefused(true);
    window.addEventListener(TENANT_READS_BLOCKED_EVENT, onBlocked);
    return () => window.removeEventListener(TENANT_READS_BLOCKED_EVENT, onBlocked);
  }, []);
  return refused || subscriptionBlocksReads(subscription);
}
